var map = {
	"./de.json": [
		465,
		5
	],
	"./en.json": [
		466,
		4
	],
	"./fr.json": [
		467,
		3
	],
	"./it.json": [
		468,
		2
	],
	"./nl.json": [
		469,
		1
	],
	"./nl_be.json": [
		470,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 180;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/locales lazy ^\.\/.*\.json$
// module id = 180
// module chunks = 9